function _isFunction(x) {
  return Object.prototype.toString.call(x) === '[object Function]';
}
module.exports = _isFunction;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/src/internal/_isFunction.js
// module id = 164
// module chunks = 0